export interface TimeSpan {
  from: string;
  to: string;
  shortcut: string;
}

export enum EQueryIdType {
  userId = 'user_id',
  clientId = 'client_id',
}
